export default __webpack_public_path__ + "static/vision3Mobile-b2b5b52f687f33fbdf038754af026aff.png";